<template>
  <kst-container class="kst-specialpriceadj-details">
    <kst-form
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :loading="isLoading"
      :title="title"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>

      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Details :data="data"/>
          <Items :data="data" :items="data.Items"/>
          <Total :data="data"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../SpecialPriceAdjInfo.js";
import Model from "../SpecialPriceAdjModel.js";
import Services from "../SpecialPriceAdjServices.js";

import Action from "./SpecialPriceAdjDetails_Action";
import Details from "./SpecialPriceAdjDetails_Details";
import Items from "./SpecialPriceAdjDetails_Items";
import Total from "./SpecialPriceAdjDetails_Total";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Details,
    Action,
    Items,
    Total
  },
  data: () => ({
    data: {},
    deliveryList: [],
    isLoading: false,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    },
    // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails(id) {
      const config = Services.getSpecialPriceAdjDetail(id);
      this.runAxios(config, null,
        this.loadDetails_Success,
        this.loadDetails_Error,
        this.loadDetails_Invalid
      );
    },
    loadDetails_Success(data) {
      this.setDetails(data);
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },
    loadDetails_Invalid(message) {
      this.formWarnings = [message];
      this.initLoad_End();
    },

    setDetails(data) {
      this.data = data;

      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
        Model.updateItemSpecialPrice(item);
      }
    }
  }
}
</script>

<style scoped lang="css" src="./_layout.css"/>